var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"moduleWrap horizontal-flex"},[_c('div',{staticClass:"horizontal-flex item-wrap"},[_c('span',{staticClass:"item-content-long"},[_vm._v("A："+_vm._s(_vm.lng))]),_c('span',{staticClass:"item-content-long"},[_vm._v("B："+_vm._s(_vm.lat))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }